import { URLS } from '../constants/urls.js';

function requestScript(data, position, searchServiceHost, payload) {
    const url = new URL(URLS.FLOW_NEXT, searchServiceHost);
    // TODO: Нужно вынести уровень общения по сети в отдельный слой(создать класс для работы с данными который под капотом спрячет способ получения данных)
    return fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            meta: {
                flow: data.flow,
                scenarioVersion: data.scenarioVersion,
                owner: '166936',
            },
            payload: {
                ...payload,
                // position: `${position}${inputSettings?.inputType === 'scenario' ? '' : '/input'}`,
                position: `${position}/input`,
            },
        }),
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json',
        },
    }).then((response) => response.json());
}

export { requestScript };
//# sourceMappingURL=requestScript.js.map
